(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["im-advent-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('im-advent')) {
    class ImAdvent extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }
      init() {
        if (this.ready) return;
        this.ready = true;
        this.board = document.getElementById('ImArBoard-' + this.dataset.section);
        if (!this.board) return;
        this.doors = Array.from(this.board.querySelectorAll('[data-door]'));
        this.count = this.querySelector('[data-advent-count]');
        this.done = this.querySelector('[data-advent-done]');
        this.allBtn = this.querySelector('[data-advent-all]');
        this.resetBtn = this.querySelector('[data-advent-reset]');
        this.timers = [];

        this.onDoor = (event) => {
          const cell = event.target.closest('.im-ar__cell');
          const door = cell ? cell.querySelector('[data-door]') : null;
          if (!door) return;
          this.setDoor(door, door.getAttribute('aria-pressed') !== 'true');
          this.update();
        };
        this.board.addEventListener('click', this.onDoor);
        this.allBtn.addEventListener('click', () => this.openAll());
        this.resetBtn.addEventListener('click', () => this.reset());
      }
      disconnectedCallback() {
        if (this.board) this.board.removeEventListener('click', this.onDoor);
        this.clearTimers();
      }
      clearTimers() {
        this.timers.forEach((t) => window.clearTimeout(t));
        this.timers = [];
      }
      setDoor(door, open) {
        door.setAttribute('aria-pressed', open ? 'true' : 'false');
        const n = door.dataset.door;
        door.setAttribute('aria-label', (open ? 'Close door ' : 'Open door ') + n);
      }
      openAll() {
        this.clearTimers();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const closed = this.doors
          .filter((d) => d.getAttribute('aria-pressed') !== 'true')
          .sort((a, b) => Number(a.dataset.door) - Number(b.dataset.door));
        closed.forEach((door, i) => {
          const t = window.setTimeout(() => {
            this.setDoor(door, true);
            this.update();
          }, reduce ? 0 : i * 70);
          this.timers.push(t);
        });
      }
      reset() {
        this.clearTimers();
        this.doors.forEach((d) => this.setDoor(d, false));
        this.update();
      }
      update() {
        const open = this.doors.filter((d) => d.getAttribute('aria-pressed') === 'true').length;
        this.count.textContent = open;
        const all = open === this.doors.length;
        this.allBtn.hidden = all;
        this.resetBtn.hidden = open === 0;
        if (this.done) this.done.hidden = !all || this.done.textContent.trim() === '';
      }
    }
    customElements.define('im-advent', ImAdvent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-delivery-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('im-countdown')) {
    class ImCountdown extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }
      init() {
        if (this.ready) return;
        this.ready = true;
        this.deadline = Date.parse(this.dataset.deadline);
        this.start = Date.parse(this.dataset.start || '');
        this.event = Date.parse(this.dataset.event || '');
        this.live = this.querySelector('[data-countdown-live]');
        this.after = this.querySelector('[data-countdown-after]');
        if (Number.isNaN(this.deadline)) {
          if (this.live) this.live.hidden = true;
          return;
        }
        this.paintTimeline();
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
      }
      paintTimeline() {
        const fill = this.querySelector('[data-countdown-fill]');
        const today = this.querySelector('[data-countdown-today]');
        const now = Date.now();
        if (fill && !Number.isNaN(this.start) && !Number.isNaN(this.event) && this.event > this.start) {
          const pct = Math.max(0, Math.min(100, ((now - this.start) / (this.event - this.start)) * 100));
          fill.style.width = pct + '%';
          if (today) today.style.left = pct + '%';
        }
        this.querySelectorAll('[data-step-date]').forEach((step) => {
          const t = Date.parse(step.dataset.stepDate);
          if (!Number.isNaN(t)) step.classList.toggle('is-past', t < now);
        });
      }
      tick() {
        const remaining = this.deadline - Date.now();
        if (remaining <= 0) {
          if (this.live) this.live.hidden = true;
          if (this.after && this.after.textContent.trim() !== '') this.after.hidden = false;
          this.paintTimeline();
          window.clearInterval(this.timer);
          return;
        }
        const s = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(s / 86400),
          hours: Math.floor((s % 86400) / 3600),
          minutes: Math.floor((s % 3600) / 60),
          seconds: s % 60,
        };
        Object.keys(values).forEach((unit) => {
          const el = this.querySelector('[data-unit="' + unit + '"]');
          if (el) el.textContent = String(values[unit]).padStart(2, '0');
        });
      }
    }
    customElements.define('im-countdown', ImCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('im-reviews')) {
    class ImReviews extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }
      init() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('[data-rv-track]');
        this.prev = this.querySelector('[data-rv-prev]');
        this.next = this.querySelector('[data-rv-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.onScroll = () => this.sync();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.sync();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.onScroll);
      }
      go(direction) {
        const card = this.track.querySelector('li');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }
      sync() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('im-reviews', ImReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-colours"] && !Shopify.designMode) return;
  try {
    
  if (!window.msPickBound) {
    window.msPickBound = true;
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-ms-pick]');
      if (!link) return;
      const option = document.querySelector('ms-product [data-ms-variant="' + link.dataset.msPick + '"]');
      if (!option) return;
      e.preventDefault();
      option.click();
      const target = option.closest('.ms-step') || option;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.msr').forEach((root) => {
    if (root.dataset.msrReady) return;
    root.dataset.msrReady = 'true';
    const track = root.querySelector('[data-msr-track]');
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.msr__card');
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    };
    const prev = root.querySelector('[data-msr-prev]');
    const next = root.querySelector('[data-msr-next]');
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step() }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-value"] && !Shopify.designMode) return;
  try {
    
  if (!window.msPickBound) {
    window.msPickBound = true;
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-ms-pick]');
      if (!link) return;
      const option = document.querySelector('ms-product [data-ms-variant="' + link.dataset.msPick + '"]');
      if (!option) return;
      e.preventDefault();
      option.click();
      const target = option.closest('.ms-step') || option;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
